import { PointRankingEntry } from './PointRankingEntry';

/**
 * Class representing a group point ranking entry.
 * @abstract
 */
export class GroupPointRankingEntry extends PointRankingEntry {}
